import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';


@customElement('pdq-tutorial-liquid')
class PDQTutorialLiquid extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {
    const code = `
<pdq-liquid>
<script type="text/liquid" slot="liquid">
<div style="color: green; padding: 15px;">Today's date is: {{ "now" | date: "%Y-%m-%d" }}</div>
</script>
</pdq-liquid>    
    `


    const code1 = `
<pdq-data-request 
  id="users-table"
  url="https://jsonplaceholder.typicode.com/users"
  index="username" 
  data-type="json"
  strategy="useStale"  
  ></pdq-data-request>
<pdq-liquid>
<script type="application/json" slot="variables">
[
  {"name": "users", "source": "users-table"}
]
</script>
<script type="text/liquid" slot="liquid">
<h1>Users:</h1>
<ul>
  {% for user in users %}
  <li>{{user.name}}</li>
  {% endfor %}
</ul>
</script>
</pdq-liquid>`;


    return html`
      <cds-tile>

        <h2>Liquid Templating </h2>
        <p>The <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-liquid</cds-tag> component allows 
          you to render liquid templates. Liquid is rendered using the 
          <a href="https://liquidjs.com/index.html">LiquidJS Engine</a></p>
        
        <h3>Example - Liquid</h3>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
        <p>This simple example shows how to use the <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-liquid</cds-tag>
        to render an arbitrary liquid template. It's a simple tag that takes a script tag with 
          <cds-tag type="gray">type="text/liquid" slot="liquid"</cds-tag>, this is passed and rendered in place.</p>

        <h3>Example - Liquid with Variables</h3>
        <p>Now lets make it more interesting and bring in data from our data model...</p>
        <pdq-code-html code="${code1}"></pdq-code-html>
        ${unsafeHTML(code1)}
        <p>Notice that now we pass in 2 templates, one has the <cds-tag type="gray">slot="variables"</cds-tag>.
        This is a json dictionary, the keys are the names of variables that will be available in the template,
        the values are the names of the view or table from the global data model</p>
      </cds-tile>
    `;
  }
}